export const dispatch = Symbol('dispatch')
export const variantable = Symbol('variantable')
